// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nQLrQ3wImw_7WJTA {
	margin-left: 12px;
	background-color: #4D87BE;
	color: #fff;
	font-weight: 500;
	font-size: 16px;
	width: fit-content;
	padding: 0 15px;
	height: 35px;
	border-radius: 200px;
	display: flex;
	justify-content: center;
	align-items: center;
}

.pQ_AdBjf2g0nCXBj {
	max-width: 1310px;
	margin: 0 auto;
	padding-bottom: 96px;
}

.pQ_AdBjf2g0nCXBj h2 {
	color: #303030;
	font-size: 30px;
	font-weight: 600;
	margin: 0;
}

.npVRs6HCZMHHL9fC {
	margin-top: 20px;
	width: 450px;
	height: 58px;
	padding: 12px 10px;
	border-radius: 16px;
	box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.05);
	background: #FFFFFF;
}

.U71A4p2aEdbppflB {
	margin: 29px 0 30px 0;
}

.pQ_AdBjf2g0nCXBj .p-datatable-table {
	border-radius: 16px;
	overflow: hidden;
}

.pQ_AdBjf2g0nCXBj .p-datatable-thead th {
	background-color: #f2e1bc;
	border: 1px solid #f3f5f7;
	padding: 18px 30px;
}

.pQ_AdBjf2g0nCXBj .p-datatable-thead th:first-child > div {
	display: flex;
	justify-content: flex-start;
}

.pQ_AdBjf2g0nCXBj .p-datatable-thead th > div {
	display: flex;
	justify-content: center;
	color: #303030;
	font-size: 18px;
}

.pQ_AdBjf2g0nCXBj .p-datatable-tbody td {
	border: 1px solid #f3f5f7;
	padding: 9px 8px;
}

.pQ_AdBjf2g0nCXBj .p-datatable-tbody tr td:first-child {
	text-align: left;
}

.pQ_AdBjf2g0nCXBj .p-datatable-tbody tr td {
	text-align: center;
}

.pQ_AdBjf2g0nCXBj .p-datatable-tbody tr:hover .ys6R5EumVzAMTv3P {
	background-color: #e1e7ed;
}

.ys6R5EumVzAMTv3P {
	padding: 28px 22px;
	border-radius: 6px;
}

.YNf9oAdV1HIwNZiS {
	width: 114px;
	height: 67px;
}

.YNf9oAdV1HIwNZiS:hover {
	background-color: #E1E7ED;
	border-radius: 6px;
}

.pQ_AdBjf2g0nCXBj .p-datatable-tbody tr:hover .YNf9oAdV1HIwNZiS {
	background-color: #e1e7ed;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Admin/components/Notifications.module.css"],"names":[],"mappings":"AAAA;CACC,iBAAiB;CACjB,yBAAyB;CACzB,WAAW;CACX,gBAAgB;CAChB,eAAe;CACf,kBAAkB;CAClB,eAAe;CACf,YAAY;CACZ,oBAAoB;CACpB,aAAa;CACb,uBAAuB;CACvB,mBAAmB;AACpB;;AAEA;CACC,iBAAiB;CACjB,cAAc;CACd,oBAAoB;AACrB;;AAEA;CACC,cAAc;CACd,eAAe;CACf,gBAAgB;CAChB,SAAS;AACV;;AAEA;CACC,gBAAgB;CAChB,YAAY;CACZ,YAAY;CACZ,kBAAkB;CAClB,mBAAmB;CACnB,4CAA4C;CAC5C,mBAAmB;AACpB;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC,mBAAmB;CACnB,gBAAgB;AACjB;;AAEA;CACC,yBAAyB;CACzB,yBAAyB;CACzB,kBAAkB;AACnB;;AAEA;CACC,aAAa;CACb,2BAA2B;AAC5B;;AAEA;CACC,aAAa;CACb,uBAAuB;CACvB,cAAc;CACd,eAAe;AAChB;;AAEA;CACC,yBAAyB;CACzB,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,YAAY;CACZ,YAAY;AACb;;AAEA;CACC,yBAAyB;CACzB,kBAAkB;AACnB;;AAEA;CACC,yBAAyB;AAC1B","sourcesContent":[".organizationLabel {\r\n\tmargin-left: 12px;\r\n\tbackground-color: #4D87BE;\r\n\tcolor: #fff;\r\n\tfont-weight: 500;\r\n\tfont-size: 16px;\r\n\twidth: fit-content;\r\n\tpadding: 0 15px;\r\n\theight: 35px;\r\n\tborder-radius: 200px;\r\n\tdisplay: flex;\r\n\tjustify-content: center;\r\n\talign-items: center;\r\n}\r\n\r\n.pageWrapper {\r\n\tmax-width: 1310px;\r\n\tmargin: 0 auto;\r\n\tpadding-bottom: 96px;\r\n}\r\n\r\n.pageWrapper h2 {\r\n\tcolor: #303030;\r\n\tfont-size: 30px;\r\n\tfont-weight: 600;\r\n\tmargin: 0;\r\n}\r\n\r\n.dropdown {\r\n\tmargin-top: 20px;\r\n\twidth: 450px;\r\n\theight: 58px;\r\n\tpadding: 12px 10px;\r\n\tborder-radius: 16px;\r\n\tbox-shadow: 2px 2px 10px rgba(0, 0, 0, 0.05);\r\n\tbackground: #FFFFFF;\r\n}\r\n\r\n.header {\r\n\tmargin: 29px 0 30px 0;\r\n}\r\n\r\n.pageWrapper :global(.p-datatable-table) {\r\n\tborder-radius: 16px;\r\n\toverflow: hidden;\r\n}\r\n\r\n.pageWrapper :global(.p-datatable-thead th) {\r\n\tbackground-color: #f2e1bc;\r\n\tborder: 1px solid #f3f5f7;\r\n\tpadding: 18px 30px;\r\n}\r\n\r\n.pageWrapper :global(.p-datatable-thead th:first-child > div) {\r\n\tdisplay: flex;\r\n\tjustify-content: flex-start;\r\n}\r\n\r\n.pageWrapper :global(.p-datatable-thead th > div) {\r\n\tdisplay: flex;\r\n\tjustify-content: center;\r\n\tcolor: #303030;\r\n\tfont-size: 18px;\r\n}\r\n\r\n.pageWrapper :global(.p-datatable-tbody td) {\r\n\tborder: 1px solid #f3f5f7;\r\n\tpadding: 9px 8px;\r\n}\r\n\r\n.pageWrapper :global(.p-datatable-tbody tr td:first-child) {\r\n\ttext-align: left;\r\n}\r\n\r\n.pageWrapper :global(.p-datatable-tbody tr td) {\r\n\ttext-align: center;\r\n}\r\n\r\n.pageWrapper :global(.p-datatable-tbody tr:hover) .cellInsider {\r\n\tbackground-color: #e1e7ed;\r\n}\r\n\r\n.cellInsider {\r\n\tpadding: 28px 22px;\r\n\tborder-radius: 6px;\r\n}\r\n\r\n.activeBtn {\r\n\twidth: 114px;\r\n\theight: 67px;\r\n}\r\n\r\n.activeBtn:hover {\r\n\tbackground-color: #E1E7ED;\r\n\tborder-radius: 6px;\r\n}\r\n\r\n.pageWrapper :global(.p-datatable-tbody tr:hover) .activeBtn {\r\n\tbackground-color: #e1e7ed;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export var organizationLabel = `nQLrQ3wImw_7WJTA`;
export var pageWrapper = `pQ_AdBjf2g0nCXBj`;
export var dropdown = `npVRs6HCZMHHL9fC`;
export var header = `U71A4p2aEdbppflB`;
export var cellInsider = `ys6R5EumVzAMTv3P`;
export var activeBtn = `YNf9oAdV1HIwNZiS`;
export default ___CSS_LOADER_EXPORT___;
